
import { createApp } from 'vue'

import App from '@/App.vue'

import router from './router'
import Quasar from 'quasar/src/vue-plugin.js';
import quasarUserOptions from './plugins/quasar'
import { initQuasarLang } from './plugins/quasar'
import pinia from './plugins/pinia'
import i18n from './plugins/i18n'

import '@vue-js-cron/light/dist/light.css'
import CronLightPlugin from '@vue-js-cron/light'
import Plugin from 'quasar-ui-q-tel-input'

// Override default props for QTelInput
const QTelInput = Plugin.QTelInput
if (QTelInput && QTelInput.props) {
  const overrides = {
    outlined: { type: Boolean, default: true },
    defaultCountry: { type: String, default: 'IT' },
    search: { type: Boolean, default: true }
  }

  for (const key in overrides) {
    if (QTelInput.props[key]) {
      QTelInput.props[key].default = overrides[key].default
    } else {
      QTelInput.props[key] = overrides[key]
    }
  }
}

import 'quasar-ui-q-tel-input/dist/index.css'
import '@/styles/style.scss'
import './registerServiceWorker'

createApp(App)
.use(Quasar, quasarUserOptions)
.use(i18n)
.use(pinia)
.use(router)
.use(CronLightPlugin)
.use(Plugin)
.mount('#app')

initQuasarLang()

